import moment from 'moment';
import { DashboardCard } from '../card';
import { CPLAT_API_ROUTES, useFetch } from '@/api';
import { useAppSelector } from '@/redux/store';
import { CplatApiResponse } from '@/types/api';

export const TodaySummary = () => {
  const now = moment();

  const formattedNow = now.format('YYYY.MM.DD HH:mm:ss');

  const user = useAppSelector((state) => state.user);

  const { data } = useFetch<
    CplatApiResponse<
      {
        totalSalesAmount: number;
        totalRevenueAmount: number;
        totalSalesCount: number;
      }[]
    >
  >(CPLAT_API_ROUTES.getSummary, {
    method: 'POST',
    params: {
      cplatToken: user.CplatToken,
      dateFrom: now.format('YYYY-MM-DD'),
      dateTo: now.format('YYYY-MM-DD'),
    },
    v3: true,
  });

  const totalSalesAmount = data?.data[0].totalSalesAmount;
  const totalRevenueAmount = data?.data[0].totalRevenueAmount;
  const totalSalesCount = data?.data[0].totalSalesCount;

  return (
    <DashboardCard>
      <div className="flex items-center justify-between">
        <span className="text-gr-900 Body1S16">오늘 요약</span>
        <span className="text-gr-600 Body5M14">{formattedNow}</span>
      </div>
      <div className="flex  items-center gap-5">
        <div className="flex-1 space-y-1">
          <span className="text-gr-700 Caption1M12">매출</span>
          <div className="flex items-end gap-2">
            <span className="text-gr-800 Title3S18">
              {totalSalesAmount ? totalSalesAmount.toLocaleString() : 0}원
            </span>
            <span className="text-gr-600 Body4S14">
              {totalSalesCount ? totalSalesCount.toLocaleString() : 0}건
            </span>
          </div>
        </div>
        <div className="h-12 w-px bg-gr-200" />
        <div className="flex-1 space-y-1">
          <span className="text-gr-700 Caption1M12">정산금</span>
          <div>
            <span className="text-gr-800 Title3S18">
              {totalRevenueAmount ? totalRevenueAmount.toLocaleString() : 0}원
            </span>
          </div>
        </div>
      </div>
    </DashboardCard>
  );
};
